import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class IncomeFeeService {
	private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
	public getAllCompanies(querySearch?: any): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.post("/api/business/companyV2?page=0&size=10000", querySearch)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	public getBusinessCpn(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/company-type")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	public getTypeOfDispatch(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/doc/bcdt-doc-types")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	public getLicNumber(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/cert/lic-numbers")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public getNetwork(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/cert/lic-types")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public LicCpnLicensee() {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/cert/lic-cpn-licenses")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public LicCpnbusinessSearch() {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/cert/telcoService/businessSearch")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public SearchincomeFee(querySearch: any, cancelToken): Promise<any> {
		let url = "/api/business/f-mgm";
		return new Promise<any>((resolve, reject) => {
			axios
				.post(url, querySearch, { cancelToken: cancelToken.token })
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					console.log(reject(err));
				});
		});
	}

	public excelTlm(querySearch?: any): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.post("/api/business/f-mgm/export/excel", querySearch, { responseType: "blob" })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.log(reject(err));
				});
		});
	}
}
